module.exports = __webpack_public_path__ + "img/how-to_image05.b2bd42eb.png";